
export const MessagesAndAlerts = (function () {

    let init = function () {
        messagesAndAlertsInit();
    }

    return {
        init: init
    }

}());


/**
 * messages-and-alerts.js
 */
function messagesAndAlertsInit()
{

    // initialise object for handling alerts modal popup
    messagesAndAlertsModal.init();
    // initialise object for handling archived alerts modal popup
    messagesAndAlertsArchivedModal.init();

    window.tableStateCache = {};

    // Temporarily disabled (see https://www.pivotaltracker.com/story/show/186040706)
    //messagesAndAlertsPreReadTableSettings();

    $("#messages-and-alerts-loading").show();

    // loads messages and alerts table
    $('#messages-and-alerts-table').bootstrapTable({
        formatNoMatches: function () {
            $(".loading-text").text("There are currently no messages or alerts.");
            $(".animation-wrap").hide();
            return '';
        }
    });


    // toggle between table and card view
    $('#toggle-button').on('click', function(e) {
        $('#messages-and-alerts-table').bootstrapTable('toggleView');
    });

    $('#archived-back-button').on('click', function(e) {
        location = "/alerts";
    });


    // This event is fired when the bootstrap-table (unarchived items) custom view has been rendered
    $('#messages-and-alerts-table-view').on('custom-view-post-body.bs.table', function(e) {
        // find all 'read' items and dim the contents
        dimReadItems();
    });


    // version 1.22.1 of bootstrap-table has a bug where ther custom view button is not
    // being hidden. So we are doing that manually here.
    $("button[name='customView']").hide();

    // if close cross button of alert message clicked then hide the message
    $("#messages-and-alerts-form-alert .close").on('click', function() {
        $('#messages-and-alerts-form-alert').addClass('d-none');
    });

    $(".back-button").on('click', function() {
        history.back()
    });

    $("#messages-and-alerts-loading").hide();

};

/**
 * search for 'read' items and dim the contents
 */
function dimReadItems() {
    // iterate over all cards and find ones with a 'new' badge that has 'myds-read-badge-active' in the class
    $('[class*=myds-card-body-alert]:not(:has([class*=myds-read-badge-active])').each( function( index ) {
        $(this).css("opacity", 0.5);
    });

}

/**
 * Get data for bootstrap unarchived table.
 * This function is configured in the boostrap-table (data-ajax="tableGetMessagesAndUnarchivedAlertsData")
 * @param {object} params - parameters for pagination, search etc.
 */
window.tableGetMessagesAndAlertsUnarchivedData = function (params) {
    window.tableGetMessagesAndAlertsData(
        '/inapp/alerts/table-get-messages-and-alerts-unarchived-data',
        params
    );
}
/**
 * Get data for bootstrap archived table.
 * This function is configured in the boostrap-table (data-ajax="tableGetMessagesAndArchivedAlertsData")
 * @param {object} params - parameters for pagination, search etc.
 */
window.tableGetMessagesAndAlertsArchivedData = function (params) {
    window.tableGetMessagesAndAlertsData(
        '/inapp/alerts/table-get-messages-and-alerts-archived-data',
        params
    );
}

/**
 * Get data for bootstrap table.
 *
 * @param string - url for ajax call
 * @param {object} params - parameters for pagination, search etc.
 */
window.tableGetMessagesAndAlertsData = function (url, params) {

    let promise = ajaxCall(url + '/' + $.param(params.data), null, 'GET');

    promise.done(function(data) {
        if (data) {
            if (data.total > 0) {
                params.success(data);
            }
        }
    });
    promise.fail(function(error) {
        Util.toggleAlert('#myds-messages-and-alerts-alert', error.responseJSON.message, 'alert-warning', -1);
        return false;
    });

}


/**
 * customStorageSet - boostrap-table calls this to set state variables
 * for the state of the table. E.g. page number, search text, card/table view
 * @param {string} param - the type of value to save (e.g. page number, search text etc.)
 * @param {string} value - the value to save.
 */
window.messagesAndAlertsCustomStorageSet = function(param, value) {

    let data = JSON.stringify({
        "instance": '0',
        "setting_name": param,
        "setting_value": String(value)
    });


    let promise = ajaxCall('/usersettings-write', data);

    promise.done(function(response) {
        if (response) {
            return(response.data);
        }
    });

};


/**
 * This function reads all the table settings in one ajax call and stores them in
 * the window.tableStateCache global object to act as a cache.
 * When bootstrap-table makes its calls to get the settings (multiple calls)
 * instead of making multiple ajax calls we return values from window.tableStateCache
 *
 * @returns Boolean
 */
window.messagesAndAlertsPreReadTableSettings = function() {

    let table_prefix = $("#messages-and-alerts-table").attr('data-cookie-id-table');
    let data = JSON.stringify({
        "instance": '0',
        "setting_name": table_prefix + '%',
        "operator": 'LIKE'
    });


    // This ajax call needs to be synchronous to ensure data has been read
    // when requested by bootstrap-table
    let promise = ajaxCall('/usersettings-read', data, 'POST', false);

    promise.done(function(response) {
        if (response) {
            // loop through the table settings returned from userSettings
            // and add them to the cache
            for (const key in response.data) {
                Object.assign(
                    window.tableStateCache,
                    {[response.data[key]['var_name']] : response.data[key]['var_value']}
                );
            }
        }
    });

    promise.fail(function(error) {
        Util.toggleAlert('#myds-messages-and-alerts-alert', error.responseJSON.message, 'alert-warning', -1);
        return false;
    });

    return true;

}


/**
 * customStorageGet - boostrap-table calls this to get any saved variables
 * for the state of the table. E.g. page number, search text, card/table view
 *
 * @param {string} param - the type of value requested (e.g. page number, search text etc.)
 */
window.messagesAndAlertsCustomStorageGet = function(param) {

    // if the setting is present in the cache
    if (window.tableStateCache[param]) {
        return window.tableStateCache[param];
    }

    return null;

};

// defined in the messages and alerts bootstrap-table but not used
window.messagesAndAlertsCustomStorageDelete = function() {
};


/**
 * messagesAndAlertsNameFormatter
 * @param {string} value - the field value.
 * @param {object} row - the row record data.
 * @param {integer} index the row index
 */
window.messagesAndAlertsNameFormatter = function(value, row, index) {

    let startDiv = `<div class="d-flex justify-content-between">`;
    let view = `<span>${value}</span>` + `<span><a href="/service-directory/service/${row.service_id}/${row.organisation_id}" ` +
            `data-id="${row.id}" data-status="${row.status}" class="view">` +
            `<button class="btn btn-sm btn-primary">View Service</button>` +
            `</a></span>`;

    return [startDiv, view, '</div>'].join('');

};


/**
 * This injects the data into the bootstrap-table templte for the custom view
 *
 * @param {*} data - the templates to be processed
 * @returns - The html for the cusom view,
 */
window.messagesAndAlertsCustomViewFormatter = function(data) {

    let template = $('#customViewTemplate').html()
    let view = '';
    let icon = '';
    let title = '';

    let icon_filename = {
        'EVENT': 'activity-icon.svg',
        'MESSAGE': 'alert-icon-green.svg',
        'REFERRAL': 'referral-accepted-green.svg',
        'default': 'alert-icon-green.svg'
    };

    let title_list = {
        'EVENT': 'Event',
        'MESSAGE': 'New Message',
        'REFERRAL': 'Referral',
        'default': 'New Alert'
    };


    $.each(data, function (i, row) {

      title = (title_list[row.type] || title_list['default']);
      icon = '/static/images/' + (icon_filename[row.type] || icon_filename['default']);

      view += template.replace('%TYPE%', title)
      .replaceAll('%UNIQUE_ID%', row.id)
      .replace('%CREATED_TIMESTAMP%', row.created_timestamp)
      .replace('%CONTENT%', row.content)
      .replace('%ICON%', icon)
      .replace('%NEW%', (row.status == 'unread' ? 'New' : ''))
      .replace('%READ_BADGE_ACTIVE%', (row.status == 'unread' ? 'myds-read-badge-active' : ''))

    })

    return `<div class="row mx-0">${view}</div>`
}


/**
 * convertDate transforms timestamp value in readable date
 * @param {string} timeStamp - the field value.
 */
let convertDate = function (timeStamp) {

  let a = new Date(timeStamp * 1000);
  let months = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];
  return a.getDate() + ' ' + months[a.getMonth()] + ' ' +  a.getFullYear();

}


// ---------------------------------------------------------------------------------------

// Object for handling alert modal popup window and its respective methods
let messagesAndAlertsModal = {

    init: function () {

        // object properties for storing which card has been selected
        // and its respective id
        messagesAndAlertsModal.alertSelectedItem = "";
        messagesAndAlertsModal.alertSelectedInAppAlertsId = 0;

        // set the onclick handler for the modal popup when a card
        // is selected
        messagesAndAlertsModal.setModalListener();

    },


    //opens modal 'alerts-events-modal' on click
    openMessagesAndAlertsModal: function(e) {

        e.preventDefault();
        e.stopPropagation();

        let alert = $(e.target).closest(".card");
        messagesAndAlertsModal.alertSelectedItem = alert;
        // store the id of the currently selected alert. For use by markMessageAs()
        messagesAndAlertsModal.alertSelectedInAppAlertsId = $(alert).attr("data-id");

        let getAlertDetails = $.ajax({
            url: '/alert-details/' + messagesAndAlertsModal.alertSelectedInAppAlertsId,
            type: 'get'
          });

        getAlertDetails.then(function(response) {  
            let details = response.alertDetails;
            messagesAndAlertsModal.populateAlertModal(alert, details);
        });
        getAlertDetails.fail(function(err) {
            console.log("failed!!");
        });

        


    },

    populateAlertModal: function(alert, details) {

        // get the image and title text from the card and inject it into the modal
        let image = $(alert).find("[id^=myds-image-alert]").attr('src');
        let badgePill = $(alert).find("[id^=myds-card-title-alert]").text().trim();
        
        $('#alerts-events-modal .modal-title').html(
            '<img src="' + image + '" class="dimension-40 mr-2">' + ' ' + badgePill);

        $("#alerts-events-modal #modal-date").text($(alert).find("[id^=myds-card-date]").text());
        $("#alerts-events-modal #modal-content").text(details.content);


        $("#alerts-events-modal #service-name").text(details.service_name);
        $("#alerts-events-modal #service-link").attr('href', '/service-directory/service/' + details.service_id);
        $("#alerts-events-modal #context-link").attr('href', '/referrals/' + details.context_id);
        

        // Determine if the selected item has already been marked as read or not
        if ($(alert).find("[id^=myds-read-badge]").text()) {
            $('.alerts-mark-unread').text('Mark as Read');
            $('.alerts-mark-unread').addClass('alerts-mark-read');
            $('.alerts-mark-unread').removeClass('alerts-mark-unread');
        } else {
            $('.alerts-mark-read').text('Mark as Unread');
            $('.alerts-mark-read').addClass('alerts-mark-unread');
            $('.alerts-mark-read').removeClass('alerts-mark-read');
        }

        $('#alerts-events-modal').modal('show');
    },

    /**
     * set the on click listener handler for the
     * alerts-events-modal modal popup
     */
    setModalListener: function() {

        // This event is fired when the bootstrap-table custom view has been rendered
        $('#messages-and-alerts-table').on('custom-view-post-body.bs.table', function(e) {
            $("[class*=messages-and-alerts-card]").on('click', function(e) {
                messagesAndAlertsModal.openMessagesAndAlertsModal(e);
            });
        });

        $('.alerts-archive').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            messagesAndAlertsModal.markMessageAs('archived');
        });

        $(".alerts-close").on('click', function(e) {
            e.preventDefault();
            $('#alerts-events-modal').modal('hide');
        });

        $("#alerts-events-modal").on('hide.bs.modal', function() {
            $('#modal-alerts-alert').addClass('d-none');
        });

        $(".modal-footer").on('click', '.alerts-mark-read', function(e) {
            e.preventDefault();
            messagesAndAlertsModal.markMessageAs('read');
        });

        $(".modal-footer").on('click','.alerts-mark-unread', function(e) {
            e.preventDefault();
            messagesAndAlertsModal.markMessageAs('unread');
        });
    },


    /**
     * mark the item as either read, unread or archived.
     * success will reload the current page to update the display
     */
    markMessageAs:  function (status) {

        // Ajax call to mark item as read/archived in the inapp_alerts dataset
        let data = JSON.stringify({
            "id" : messagesAndAlertsModal.alertSelectedInAppAlertsId,
            "status" : status
        });

        ajaxCall('/inapp/alerts/set-alert', data).done(function(response) {
            // reload the page to update the display.
            location.reload();
            return response.success;
        }).fail(function(error) {
            Util.toggleAlert('#modal-alerts-alert', `Error: Unable to mark message as ${status}`, 'alert-warning', -1);
            return false;
        });

    },

}


let messagesAndAlertsArchivedModal = {

    init: function () {

        messagesAndAlertsArchivedModal.alertSelectedItem = "";
        messagesAndAlertsArchivedModal.alertSelectedInAppAlertsId = 0;
        messagesAndAlertsArchivedModal.hostname = 'https://' + document.location.hostname;
        messagesAndAlertsArchivedModal.currentOrder = "";

        messagesAndAlertsArchivedModal.getCurrentOrder();
        messagesAndAlertsArchivedModal.setOrderButton();


        // This event is fired when the bootstrap-table custom view has been rendered
        $('#messages-and-alerts-table').on('custom-view-post-body.bs.table', function(e) {
            $(".unarchive").on('click', function(e) {
                e.preventDefault();

                let alert = $(e.target).closest(".card");
                messagesAndAlertsArchivedModal.alertSelectedItem = alert;

                messagesAndAlertsArchivedModal.alertSelectedInAppAlertsId = $(alert).attr("data-id");
                messagesAndAlertsArchivedModal.markMessageAsUnarchived();

                // reload the page if the last item has just been deleted so as to show
                // the 'There are currently no messages or alerts' message correctly.
                if ($('.messages-and-alerts-card').length == 1) {
                    location.reload();
                }
            });
        });

    },

    /**
     * Determine the ordering of the current page - either by date (default) or by 'from'
     */
    getCurrentOrder: function() {
        let url = $(location).attr("href");
        let last_slash = url.lastIndexOf('/');
        messagesAndAlertsArchivedModal.currentOrder = (url.substring(last_slash + 1) == 'from') ? 'from' : "";
    },

    /**
     * Set the text of the ordering button and set click handler for the button
     */
    setOrderButton: function() {

        let orderButtonText = messagesAndAlertsArchivedModal.currentOrder == 'alert_from' ? 'Date' : 'From';
        $('#archived-sort-button').text("Order by " + orderButtonText);

        $("#archived-sort-button").on('click', function(e) {
            e.preventDefault();

            let sortField = "";
            let sortOrder = "";
            if (messagesAndAlertsArchivedModal.currentOrder == 'alert_from') {
                sortField = "created_timestamp";
                sortOrder = 'DESC';
            } else {
                sortField = "alert_from";
                sortOrder = 'ASC';
            }
            messagesAndAlertsArchivedModal.currentOrder = sortField;
            let orderButtonText = messagesAndAlertsArchivedModal.currentOrder == 'alert_from' ? 'Date' : 'From';
            $('#archived-sort-button').text("Order by " + orderButtonText);

            $('#messages-and-alerts-table').bootstrapTable('sortBy', {
                field: sortField,
                sortOrder: sortOrder
            });
            $('#messages-and-alerts-table').bootstrapTable("refresh");


        });

    },

    /**
     * remove the selected item (alert/message) from the list
     */
    markMessageAsUnarchived:  function () {
        // Ajax call to mark item as read in the inapp_alerts dataset
        let data = JSON.stringify({
            "id" : messagesAndAlertsArchivedModal.alertSelectedInAppAlertsId,
            "read_timestamp": 0,
            "status" : 'unread'
        });

        ajaxCall('/inapp/alerts/set-alert', data).done(function(response) {
            $(messagesAndAlertsArchivedModal.alertSelectedItem).remove();
            return response.success;
        }).fail(function(error) {
            Util.toggleAlert('#myds-archived-messages-and-alerts-alert', "Error: Unable to mark message as unarchived", 'alert-warning', -1);
            return false;
        });

    },

}

/**
 * Post/Get ajax call to query for data
 * @param {string} endpoint string containing the URL to which the request is sent.
 * @param {*} data data to be sent to the server.
 * @param {string} type - ajax call type (defaults to POST)
 * @param {boolean} is_asynch - if the call is synchronous or asynchronous
 * @returns Deferred object response
 */
let ajaxCall = function(endpoint, data, type = 'POST', is_asynch = true) {

    let csrf = Util.getCSRF();

    return $.ajax({
      url: endpoint,
      type: type,
      data: data,
      async: is_asynch,
      cache: is_asynch,

      headers: {
        'x-csrf-token': csrf
      },
      dataType: "json",
      contentType: "application/json",
      timeout: 10000,  // set timeout to 10 seconds
    });
  }



